import React from 'react';
import Link from 'gatsby-link';
import moment from 'moment';
import './style.scss';

class Post extends React.Component {
  render() {
    const { title, date, category, description, conference } = this.props.data.node.frontmatter;
    const { slug, categorySlug } = this.props.data.node.fields;
    const index = this.props.index;

    let d = description.split("Shang-Yu Su");
    // console.log(this.props);
    /*
    return (
      <div className="post">
        <div className="post__meta">
          <time className="post__meta-time" dateTime={moment(date).format('MMMM D, YYYY')}>
            {moment(date).format('MMMM YYYY')}
          </time>
          <span className="post__meta-divider" />
          <span className="post__meta-category" key={categorySlug}>
            <Link to={categorySlug} className="post__meta-category-link">
              {category}
            </Link>
          </span>
        </div>
        <h2 className="post__title">
          <Link className="post__title-link" to={slug}>{title}</Link>
        </h2>
        <p className="post__description">{description}</p>
        <Link className="post__readmore" to={slug}>Read</Link>
      </div>
    );
    */
    /*
    return (
      <div className="post">
        <div className="post__meta">
          <span className="post__meta-time">
            {conference}
          </span>
          <span className="post__meta-divider" />
          <span className="post__meta-category" key={categorySlug}>
            <Link to={categorySlug} className="post__meta-category-link">
              {category}
            </Link>
          </span>
        </div>
        <h2 className="post__title">
          <Link className="post__title-link" to={slug}>{title}</Link>
        </h2>
        <p className="post__description">{description}</p>
      </div>
    );
    */
    return (
      <div className="post">
        <div className="post__meta">
          <span className="post__meta-time">
            {index+1}. {conference}
          </span>
          <span className="post__meta-divider" />
          <span className="post__meta-category" key={categorySlug}>
            <Link to={categorySlug} className="post__meta-category-link">
              {category}
            </Link>
          </span>
        </div>
        <h2 className="post__title">
          <Link className="post__title-link" to={slug}>{title}</Link>
        </h2>
        <p className="post__description">
          <p style={{display: "inline"}}>{d[0]}</p>
          <p style={{fontWeight: "bolder", display: "inline"}}>Shang-Yu Su</p>
          <p style={{display: "inline"}}>{d[1]}</p>
        </p>
      </div>
    );
  }
}

export default Post;



// WEBPACK FOOTER //
// ./src/components/Post/index.jsx